import { Injectable, EventEmitter } from '@angular/core';
import {
  AsyncValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import {
  BaseFpxDataService,
  CreateFn,
  FindAllFn,
  FindByKeyFn,
  HttpRequest,
  LookUpFn,
  ModifyFn,
  CriteriaQuery,
  HttpProviderService
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
 import { Transfersfilter, TransfersfilterMaintanence } from './transfersfilter.model';
@Injectable()
export class TransfersfilterService implements BaseFpxDataService<any> {
 constructor(private _httpProvider : HttpProviderService) { }
  create(payload: Transfersfilter): CreateFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('POST');
      httpRequest.setResource('/transfersfilter');
      let bodyContent = {"transfersfilter":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
 
  findByKey(key: Transfersfilter): FindByKeyFn<Transfersfilter|null> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/transfersfilter');
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res.body?.transfersfilter ?? null),catchError((err:any) => {
              return of(null)
            }));
        
    };
  }

  modify(payload: Transfersfilter): ModifyFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/transfersfilter');
     httpRequest.setMethod('PUT');
      let bodyContent = {"transfersfilter":payload};
      httpRequest.setBody(bodyContent);
      return this._httpProvider.invokeRestApi(httpRequest);
    };
  }
  
  
 findAll(criteriaQuery: CriteriaQuery): FindAllFn<Transfersfilter[]> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setResource('/transfersfilter');
      httpRequest.setMethod('GET');
      httpRequest.setCriteriaQuery(criteriaQuery);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<TransfersfilterMaintanence>) =>
              res.body.transfersfilter
          )
        );
    };
  }
  
   
     lookup(key: any): LookUpFn<any> {
    return () => {
      const httpRequest = new HttpRequest();
      httpRequest.setMethod('GET');
      httpRequest.setResource('/transfersfilter');
      httpRequest.addQueryParameter('lookup', 1);
      const httpCriteria = new CriteriaQuery();
	  httpCriteria.setPaginationCriteria('1', 10);
	  httpCriteria.addFilterCritertia('text', 'String', 'startsWith', {
	  searchText: key.searchText ?? '',
	  });
	  httpRequest.setCriteriaQuery(httpCriteria);
 
      return this._httpProvider.invokeRestApi(httpRequest).pipe(
        map((res: IHttpSuccessPayload<ILookupResponse>) => {
          return res.body?.Data;
        })
      );
    };
  }
}
